import { createFileRoute } from '@tanstack/react-router';
import { ProjectThemePage } from '../features/projects/project-theme-page';
export const Route = createFileRoute('/manage/$companySlug/projects/$projectId/theme')({
  component: RouteComponent,
});
function RouteComponent() {
  const { companySlug, projectId } = Route.useParams();
  return <ProjectThemePage companySlug={companySlug} projectId={projectId} />;
}
